import React from "react";
import './HighConvertingPage.css';
import HighConvertingSection from "../../Sections/HighConvertingSection/HighConvertingSection";

export default function HighConvertingPage(){
    return(
        <>
        <HighConvertingSection/>
        </>
    );
}